/* ==========================================================================
   rx-consent.js — Rolex consent cookies from CookieYes. Plain JS.

   rlx-consent   = CookieYes "advertisement" (Rolex: Adobe Analytics)
   rlx-marketing = CookieYes "other"
   "true" / "false", 7 days, path=/. Launch reads them when it loads, so a
   change applies from the next page view (no reload). The first values are set
   inline in snippets/rx-head.liquid before Launch; this file keeps them in sync:
     - window.getCkyConsent() when CookieYes has loaded,
     - the "cookieyes_consent_update" event, plus the banner buttons as a fallback,
     - the "false" defaults re-set every 250 ms for 5 s while the cookies are
       missing (no CookieYes choice yet),
     - the Rolex Corners iframe (#rlx-corner): consentTrue + consentValidation,
       or consentFalse, to the iframe's own origin (cornersv7.rolex.com), on
       every sync and once after the iframe loads.
   ========================================================================== */
(function () {
  'use strict';

  var DAYS = 7;
  var BUTTONS = '.cky-prefrence-btn-wrapper .cky-btn, .cky-notice-btn-wrapper .cky-btn';

  function getCookie(name) {
    var match = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value) {
    document.cookie = name + '=' + value + '; max-age=' + DAYS * 86400 + '; path=/';
  }

  function ensureDefaults() {
    if (getCookie('rlx-consent') === null) setCookie('rlx-consent', 'false');
    if (getCookie('rlx-marketing') === null) setCookie('rlx-marketing', 'false');
  }

  // { analytics: bool, marketing: bool } from CookieYes, or null when it has no choice to give.
  function readCookieYes() {
    if (typeof window.getCkyConsent === 'function') {
      try {
        var consent = window.getCkyConsent();
        if (consent && consent.categories) {
          return {
            analytics: consent.categories.advertisement === true,
            marketing: consent.categories.other === true
          };
        }
      } catch (e) { /* fall back to the cookie */ }
    }
    var cookie = getCookie('cookieyes-consent');
    if (!cookie) return null;
    return {
      analytics: /(^|,)advertisement:yes(,|$)/.test(cookie),
      marketing: /(^|,)other:yes(,|$)/.test(cookie)
    };
  }

  function cornerFrame() {
    var frame = document.getElementById('rlx-corner');
    return frame && frame.tagName === 'IFRAME' ? frame : null;
  }

  function tellCorner(frame) {
    frame = frame || cornerFrame();
    if (!frame || !frame.contentWindow) return;
    var origin;
    try { origin = new URL(frame.src).origin; } catch (e) { return; }
    var granted = getCookie('rlx-consent') === 'true';
    try {
      if (granted) {
        frame.contentWindow.postMessage('consentTrue', origin);
        frame.contentWindow.postMessage('consentValidation', origin);
      } else {
        frame.contentWindow.postMessage('consentFalse', origin);
      }
    } catch (e) { /* ignore */ }
  }

  function sync() {
    var consent = readCookieYes();
    if (consent) {
      setCookie('rlx-consent', consent.analytics ? 'true' : 'false');
      setCookie('rlx-marketing', consent.marketing ? 'true' : 'false');
    } else {
      ensureDefaults();
    }
    tellCorner();
  }

  // The Corners iframe is added later by retailer.js: send the state once it has loaded.
  function watchCorner() {
    if (!document.querySelector('rx-corner')) return;
    function attach(frame) {
      if (frame.__rxConsentBound) return;
      frame.__rxConsentBound = true;
      frame.addEventListener('load', function () { tellCorner(frame); });
    }
    var frame = cornerFrame();
    if (frame) return attach(frame);
    var observer = new MutationObserver(function () {
      var found = cornerFrame();
      if (!found) return;
      observer.disconnect();
      attach(found);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  sync();
  watchCorner();

  document.addEventListener('cookieyes_consent_update', sync);
  // Fallback: the banner's own buttons (CookieYes writes its cookie right after the click).
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest(BUTTONS)) setTimeout(sync, 300);
  });

  var ticks = 0;
  var keeper = setInterval(function () {
    ticks += 1;
    ensureDefaults();
    if (ticks >= 20) clearInterval(keeper);
  }, 250);
})();
